var _g, _g2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMandrakeLogoLargeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 106,
    viewBox: "0 0 121 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_242_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.945 53C106.945 80.6142 84.5588 103 56.9446 103C29.3303 103 6.94458 80.6142 6.94458 53C6.94458 25.3858 29.3303 3 56.9446 3C84.5588 3 106.945 25.3858 106.945 53Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_242_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.945 53C109.945 82.2711 86.2157 106 56.9446 106C27.6735 106 3.94458 82.2711 3.94458 53C3.94458 23.7289 27.6735 0 56.9446 0C86.2157 0 109.945 23.7289 109.945 53ZM56.9446 103C84.5588 103 106.945 80.6142 106.945 53C106.945 25.3858 84.5588 3 56.9446 3C29.3303 3 6.94458 25.3858 6.94458 53C6.94458 80.6142 29.3303 103 56.9446 103Z",
    fill: "url(#paint0_linear_242_12)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34272 70.8888C0.299305 71.1031 -0.207213 67.9449 1.80325 67.5212C21.7983 63.3074 47.1886 57.8785 69.03 52.9646C93.5141 47.4562 104.941 36.5912 108.086 36.8499V36.8499C124.581 38.2071 111.258 64.6727 94.7357 63.7083C82.9717 63.0217 70.5005 62.8181 59.4376 63.733C32.8252 65.934 7.15333 70.3842 2.34272 70.8888V70.8888Z",
    fill: "url(#paint1_linear_242_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0131 18.9599C56.6219 18.9396 57.0935 19.4785 57.012 20.0821C55.9356 28.0572 55.3055 33.3825 55.1217 36.0581C54.5442 44.4635 54.3738 49.9577 54.6103 52.5406V52.5406C54.682 53.4517 55.9167 53.6745 56.3023 52.846L73.0293 16.9029C73.2893 16.3441 73.9877 16.1517 74.5035 16.4889C78.1972 18.9039 82.187 20.9911 86.4727 22.7506C89.3753 23.9423 92.4137 24.9837 95.5879 25.8747C96.0638 26.0083 96.3758 26.466 96.3164 26.9568C95.834 30.9442 95.1288 35.1823 94.2009 39.6712C93.4783 43.1664 92.6207 46.8136 91.6281 50.6128C89.2691 59.641 87.12 66.8207 85.1806 72.152L82.3977 79.8022C82.3163 80.0259 82.1591 80.2137 81.9498 80.3271C77.6196 82.6747 71.0475 84.2323 62.2334 85C61.5111 85.0629 60.971 84.3538 61.2128 83.6703C63.2301 77.9676 64.9178 72.4533 66.2759 67.1275C67.8315 61.3559 68.8235 57.16 69.2519 54.54V54.54C69.3646 53.6723 68.17 53.2679 67.7238 54.0205C67.1946 54.9132 66.6144 55.8809 65.9833 56.9235C64.478 59.5524 61.6731 63.6236 57.5685 69.1373C53.9854 73.9875 50.7853 77.5792 47.9682 79.9124C47.4671 80.3273 46.7205 80.1223 46.4957 79.5118C45.3629 76.4351 44.4476 72.5363 43.7497 67.8154C42.9583 62.4621 42.484 57.9172 42.3267 54.1806L42.2332 51.9589C42.1913 50.9633 40.9229 50.6601 40.4572 51.5411C40.2543 51.925 40.0405 52.3333 39.8158 52.7662C38.944 54.6106 37.6053 59.031 35.8 66.0273C34.1889 72.5745 33.0812 79.6991 32.4766 87.4012C32.4184 88.1423 31.6063 88.568 30.9741 88.1769C30.2697 87.7412 29.4606 87.2295 28.5467 86.6419C27.0433 85.6278 24.8192 83.6535 21.8746 80.719C19.0122 77.8664 17.1205 75.1196 16.1995 72.4786C16.1475 72.3296 16.1351 72.1697 16.1595 72.0138C17.4918 63.4986 19.2846 55.3809 21.5376 47.6605C23.8173 39.786 25.7822 34.0839 27.4322 30.5542L29.6405 25.4762C29.7381 25.2517 29.9144 25.0704 30.1374 24.9695C33.502 23.4479 37.7057 22.1 42.7484 20.9258C47.5842 19.7485 52.0058 19.0932 56.0131 18.9599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3878 32.3829C89.3878 35.6031 86.7774 38.2135 83.5572 38.2135C80.337 38.2135 77.7266 35.6031 77.7266 32.3829C77.7266 29.1627 80.337 26.5523 83.5572 26.5523C86.7774 26.5523 89.3878 29.1627 89.3878 32.3829Z",
    fill: "url(#paint2_linear_242_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_242_12",
    x: -5.05542,
    y: -9,
    width: 124,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_242_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_242_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_242_12",
    x: -8.05542,
    y: -12,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_242_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_242_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_12",
    x1: 56.9446,
    y1: 0.00000841167,
    x2: 139.871,
    y2: 96.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2293EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#751DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_242_12",
    x1: 54.0691,
    y1: 46.1871,
    x2: 83.9093,
    y2: 87.4391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DE4D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_242_12",
    x1: 79.9131,
    y1: 28.0099,
    x2: 86.4725,
    y2: 36.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ACD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D2C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandrakeLogoLargeWhite);
export default __webpack_public_path__ + "static/media/mandrake-logo-large-white.b5822e2a4ba382bd81d9a41a480e702a.svg";
export { ForwardRef as ReactComponent };